import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia";

export default function DetallesView({
  fechaOrden,
  clienteId,
  clientes,
  usuario,
  productos,
  descuento,
}) {
  const cliente = clientes.find((c) => c.id === clienteId);
  const nombreCliente = cliente ? cliente.empresa : "Cliente no encontrado";
  const { formatDate } = useFunctionsPrevia();

  const formatCurrency = (n) =>
    new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 2,
    }).format(n);

  const subtotal = productos.reduce(
    (sum, p) => sum + parseFloat(p.importe || 0),
    0
  );
  const descVal = subtotal * (descuento / 100);
  const base = subtotal - descVal;
  const iva = base * 0.16;
  const total = base + iva;

  return (
    <div className="detalles-container">
      {/* Sección Cliente */}
      <div className="cliente-section">
        <div className="cliente-header">
          <h3>Cliente</h3>
          <span>Fecha de Creación: {formatDate(fechaOrden)}</span>
        </div>
        <div className="cliente-info">
          <p>
            <strong>Nombre:</strong> {nombreCliente}
          </p>
          <p>
            <strong>Usuario:</strong> {usuario}
          </p>
        </div>
      </div>

      {/* Tabla de productos */}
      <table className="detalles-table">
        <thead>
          <tr>
            <th>PD</th>
            <th>Productos</th>
            <th>Precio</th>
            <th>Cantidad</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {productos.map((p, i) => (
            <tr key={p.id}>
              <td>{i + 1}</td>
              <td>{p.nombre}</td>
              <td>{formatCurrency(parseFloat(p.tarifa))}</td>
              <td>{p.cantidad}</td>
              <td>{formatCurrency(parseFloat(p.importe))}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Contenedor para alinear el resumen a la derecha */}
      <div className="resumen-gastos-container">
        <div className="resumen">
          <div className="resumen-row">
            <span>Subtotal:</span>
            <span>{formatCurrency(subtotal)}</span>
          </div>
          {descuento > 0 && (
            <div className="resumen-row">
              <span>Descuento:</span>
              <span>-{formatCurrency(descVal)}</span>
            </div>
          )}
          <div className="resumen-row">
            <span>IVA (16%):</span>
            <span>{formatCurrency(iva)}</span>
          </div>
          <div className="resumen-row total">
            <span>Total:</span>
            <span>{formatCurrency(total)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
